import React from 'react';
import { formatMoney } from '../utils/paymentSummary';

export function PaymentTaxBreakdown({ summary, className = '' }) {
  if (!summary) return null;

  return (
    <div className={`d-flex flex-column text-right ${className}`.trim()}>
      <span className="mb-1">
        <span className="font-weight-bolder">Subtotal: </span>
        {formatMoney(summary.subtotal)}
      </span>
      <span className="mb-1">
        <span className="font-weight-bolder">State tax: </span>
        {formatMoney(summary.stateTaxTotal)}
      </span>
      <span className="mb-1">
        <span className="font-weight-bolder">Municipal tax: </span>
        {formatMoney(summary.municipalTaxTotal)}
      </span>
      <span className="mb-1">
        <span className="font-weight-bolder">Total tax: </span>
        {formatMoney(summary.taxTotal)}
      </span>
      <span className="font-weight-bolder">
        Grand total: {formatMoney(summary.grandTotal)}
      </span>
    </div>
  );
}
